import { clientApi } from './CLIENT';

const url = '/api/dashboard/upload-carbon-form-file';
// eslint-disable-next-line no-return-await
export default async (body) => await clientApi(true).post(url, body);
